import { render, staticRenderFns } from "./vSubMissionPopup.vue?vue&type=template&id=2bad8257&scoped=true"
import script from "./vSubMissionPopup.vue?vue&type=script&lang=js"
export * from "./vSubMissionPopup.vue?vue&type=script&lang=js"
import style0 from "./vSubMissionPopup.vue?vue&type=style&index=0&id=2bad8257&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad8257",
  null
  
)

export default component.exports